import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const IconText = ({ icon, children, extra, className }) => (
    <div className={["flex my-5 text-gray", className || ""].join(" ")}>
        <FontAwesomeIcon icon={["fal", icon]} className="mr-2 mt-1" fixedWidth />
        <div>
            {children}
            {extra &&
                <p className="whitespace-pre-line text-gray-500 leading-snug mt-1 mb-0 text-sm">{extra}</p>
            }
        </div>
    </div>
)

export default IconText
